
import store from '../config/store'

export default {
  components: {
    'component-placeholder':  () => import(/* webpackChunkName: "components" */ '../components/Placeholder.vue'),
    'component-header': () => import(/* webpackChunkName: "components" */ '../components/Header.vue'),
  },

  data: () => ({
    store,
  }),

  computed: {
    hasAccount () {
      return store.data.user.accounts.length
    },
  },

  mounted () {
    if (this.hasAccount) {
      this.$router.push('/')
    }
  },
}

